import qs from "qs";
import { useConfig } from "../components/proposals/contexts/configContext";

let windowQuery: any = {};
try {
  windowQuery = qs.parse(window.location.search.substring(1));
} catch (err) {
  console.error("error parsing window query string", err);
}

const streamChatFeature = "marketplace_proposal_stream_chat";

function useSplitIOConfig(splitKey: string): SplitIO.IBrowserSettings {
  const { splitIOApiKey } = useConfig();

  return {
    core: {
      authorizationKey: windowQuery.mockSplits ? "localhost" : splitIOApiKey,
      key: splitKey,
    },
    features: {
      [streamChatFeature]: "on",
      ...(windowQuery.mockSplitFeatures || {}),
    },
  };
}

export { useSplitIOConfig, streamChatFeature };
